import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    audit_id: null,
    point: null
};

const auditSlice = createSlice({
    name: 'audit',
    initialState,
    reducers: {
        setAudit_id: (state, action) => {
            state.audit_id = action.payload;
        },
        setPoint: (state, action) => {
            state.point = action.payload;
        }
    }
});

export const { setAudit_id, setPoint } = auditSlice.actions;
export const selectAudit_id = (state) => state.audit.audit_id;
export const selectPoint = (state) => state.audit.point;

export default auditSlice.reducer;
